<template>
  <div class="package-container">
    <div v-for="pack in values" :key="pack.publicId" class="package" :class="{ active: value === pack.publicId, disabled }">
      <div class="line title">
        {{ pack.name }}
      </div>
      <!-- <div class="line title">
        {{pack.description || $t('identityFolder')}}
      </div> -->
      <div class="price-container">
        <div class="price min">
          <div class="line sub-title">{{ $t('price') }}</div>
          <div class="line bold-price">{{ pack.price }} €</div>
        </div>
        <!-- <div class="price max">
          <div class="line sub-title">{{$t('priceMax')}}</div>
          <div class="line bold-price ">{{pack.max_price || 'XXX €'}}</div>
        </div> -->
      </div>
      <div class="access">
        <div class="title">{{ $t('packageGiveAccessInfo') }}</div>
        <div v-for="access in pack.description.split('|')" :key="access" class="line">
          <div class="icon" />
          <span>{{ access }}</span>
        </div>
      </div>
      <div class="btn-container">
        <div class="main-button" :class="{ active: value === pack.publicId }" @click="setValue(pack.publicId)">
          {{ value === pack.publicId ? $t('select') : $t('choose') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },

    values: {
      type: Array,
      required: true,
    },

    onChange: {
      type: Function,
      required: false,
    },

    value: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      active: false,
    };
  },

  methods: {
    setValue(value) {
      this.active = false;
      this.onChange(value);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.package-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  .line {
    display: flex;
    align-items: center;
  }

  .package {
    height: 460px;
    width: 315px;
    min-width: 315px;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 30px;
    display: flex;
    flex-direction: column;
    background: rgba(colors.$lightgrey-color, 0.1);
    border: 1px solid transparent;
    transition: all 0.3s;

    margin: 0 24px 0 0;

    &.active {
      border: 1px solid colors.$lightblue-color;
      background: colors.$white-color;
    }

    .sub-title {
      margin: 10px 0;
      color: colors.$darkgrey-color;
      font-size: 14px;
    }

    .title {
      color: colors.$lightblue-color;
      font-size: 16px;
      font-weight: 500;
    }

    .bold-price {
      font-weight: 600;
      font-size: 18px;
    }

    .price-container {
      margin: 30px 0 0;
      display: flex;
      flex-grow: 1;

      .price {
        width: 128px;
        max-height: 80px;

        &:nth-child(2n) {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .line {
            padding-left: 32px;
            justify-content: flex-start;
          }
        }

        &:nth-child(2n + 1) {
          display: flex;
          flex-direction: column;
          .line {
            padding-right: 32px;
          }
        }
      }
    }

    .access {
      margin: 0px 0 12px;
      height: 180px;

      .title {
        margin: 30px 0 12px;
        color: colors.$darkgrey-color;
        font-size: 13px;
        font-weight: 500;
      }

      .line {
        margin: 0 0 12px;

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;

          width: 16px;
          height: 16px;
          background: colors.$lightgreen-color;
          border-radius: 50%;
          position: relative;
          margin: 0 8px 0 0;

          &:after {
            content: '';
            position: absolute;
            left: 6px;
            top: 4px;
            width: 4px;
            height: 6px;
            border-bottom: 1px solid colors.$white-color;
            border-right: 1px solid colors.$white-color;
            transform: rotate(45deg);
          }
        }

        span {
          font-size: 13px;
          line-height: 20px;
          color: colors.$grey-color;
        }
      }
    }
    .btn-container {
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: center;

      .main-button {
        max-width: 128px;

        &:hover {
          cursor: pointer;
          transform: scale(1.1);
          opacity: 0.9;
        }

        &.active {
          background: colors.$lightblue-color;

          &:hover {
            transform: scale(1);
            opacity: 1;
          }
        }
      }
    }

    &.disabled {
      .btn-container {
        .main-button {
          background: colors.$lightgrey-color;

          &.active {
            background: colors.$lightgrey-color;
          }

          &:hover {
            cursor: not-allowed;
            transform: scale(1);
            opacity: 1;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-medium) {
  .package-container {
    flex-direction: column;

    .package {
      width: 100% !important;
      margin: 12px !important;
    }
  }
}
</style>
